export const ADD_TO_ERROR_D_LIST = "ADD_TO_ERROR_D_LIST"
export const REMOVE_FROM_ERROR_D_LIST = "REMOVE_FROM_ERROR_D_LIST"
export const ADD_TO_LAST_D_LIST = "ADD_TO_LAST_D_LIST"
export const REMOVE_FROM_LAST_D_LIST = "REMOVE_FROM_LAST_D_LIST"
export const CLEAR_DROP_LIST = "CLEAR_DROP_LIST"
export const CLEAR_DROP_LAST_LIST = "CLEAR_DROP_LAST_LIST"
